import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';
import getLocal from '@/app/utils/i18n';

export default function Comp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();
    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744341009317/icon1.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744880683781/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744880683781/1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744880682443/1-h5.jpg',
            title: t('H_item1_title'),
            desc: t('H_item1_desc'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744341009943/icon2.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744889721707/20250413.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744889721707/20250413.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744341936719/3-h5.jpg',
            title: t('H_item2_title'),
            desc: t('H_item2_desc'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744341009767/icon3.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744340841097/2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744340841097/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744341936514/2-h5.jpg',
            title: t('H_item3_title'),
            desc: t('H_item3_desc'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744341009578/icon4.png',
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744880682948/2-4.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744880684031/2-4-ss.jpg',
            pad:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744880682948/2-4.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744880684031/2-4-ss.jpg',
            h5:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744880684463/2-4-h5.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744880683563/2-4-h5-ss.jpg',
            title: t('H_item4_title'),
            desc: t('H_item4_desc'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/upload/image/1744681454371/icon_sleep%401x%202.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744340840896/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744340840896/5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744341937075/5-h5.jpg',
            title: t('H_item5_title'),
            desc: t('H_item5_desc'),
        },
    ];
    return (
        <div className={styles.comp} id="ListA2">
            {/* <EcoSpace /> */}
            <EcoSectionCarousel theme="black" title={t('H_title')} items={itemsA} />
            <EcoSpace />
        </div>
    );
}
